import { css } from "@linaria/core"

export function getPrStatusClassName(kind: string) {
  switch (kind.toLowerCase()) {
    case "open":
      return styles.Open
    case "closed":
      return styles.Closed
    case "draft":
      return styles.Draft
    case "merged":
      return styles.Merged
  }
}

const styles = {
  Closed: css`
    color: var(--text-color-40);
    background-color: var(--text-color-10);
    text-transform: uppercase;
  `,

  Open: css`
    color: #0DA35C;
    background-color: rgb(0 255 51 / 20%);
    text-transform: uppercase;
  `,

  Merged: css`
    color: var(--main-color);
    background-color: rgb(119 104 255 / 15%);
    text-transform: uppercase;
  `,

  Draft: css`
    color: var(--text-color-40);
    background: var(--text-color-2);
    text-transform: uppercase;
  `,
}